export default __webpack_public_path__ + "static/media/download-googleplay-de.a27f5ad7.png";